angular.module("acl.common.aclUiDatepicker", ["acl.common.filters"]);
